import React, { useEffect, useState } from "react";
import axios from "axios";

const API = process.env.REACT_APP_API_URL;
const token = sessionStorage.getItem("token");

const ReconocimientoModal = ({
    visible,
    onClose,
    reconocimiento,
}) => {
    const [documento, setDocumento] = useState(null);

    useEffect(() => {
        const fetchDocumento = async () => {
            try {
                const idDoc =
                    reconocimiento?.iddocumento ||
                    reconocimiento?.idDocumento;

                if (!idDoc) {
                    setDocumento(null);
                    return;
                }

                const res = await axios.get(
                    `${API}/documentos/${idDoc}/`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                setDocumento(res.data);
            } catch {
                setDocumento(null);
            }
        };

        if (visible && reconocimiento) {
            fetchDocumento();
        }
    }, [visible, reconocimiento]);

    if (!visible || !reconocimiento) return null;

    const formatDate = (dateStr) => {
        if (!dateStr) return "-";

        const fecha = new Date(dateStr);

        return fecha.toLocaleDateString("es-GT", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        });
    };

    const Section = ({ title, children }) => (
        <section style={{ marginBottom: 24 }}>
            <h4
                style={{
                    margin: "0 0 12px 0",
                    fontSize: 19,
                    fontWeight: 800,
                    borderBottom: "1px solid #e5e7eb",
                    paddingBottom: 6,
                }}
            >
                {title}
            </h4>

            {children}
        </section>
    );

    const infoBoxStyle = {
        background: "#f9fafb",
        border: "1px solid #eef2f7",
        borderRadius: 12,
        padding: 12,
    };

    return (
        <div
            style={{
                position: "fixed",
                inset: 0,
                background: "rgba(0,0,0,.45)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 4000,
                padding: "0 20px",
            }}
        >
            <div
                style={{
                    width: "min(900px, 90vw)",
                    maxHeight: "92vh",
                    overflowY: "auto",
                    background: "#fff",
                    boxShadow: "0 10px 40px rgba(0,0,0,.25)",
                    padding: 28,
                    borderRadius: 16,
                    position: "relative",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginBottom: 16,
                    }}
                >
                    <button
                        onClick={onClose}
                        style={{
                            width: 36,
                            height: 36,
                            borderRadius: "999px",
                            border: "1px solid #e5e7eb",
                            background: "#f9fafb",
                            cursor: "pointer",
                            fontSize: 18,
                            fontWeight: 700,
                        }}
                    >
                        ✕
                    </button>
                </div>

                <h3
                    style={{
                        marginBottom: 20,
                        fontSize: 28,
                        textAlign: "center",
                    }}
                >
                    Detalle del Reconocimiento
                </h3>

                <Section title="Información General">
                    <div
                        style={{
                            display: "grid",
                            gridTemplateColumns:
                                "repeat(auto-fit, minmax(240px, 1fr))",
                            gap: 14,
                        }}
                    >
                        <div style={infoBoxStyle}>
                            <div
                                style={{
                                    fontSize: 12,
                                    textTransform: "uppercase",
                                    color: "#6b7280",
                                    marginBottom: 6,
                                }}
                            >
                                Trabajador/a
                            </div>

                            <div
                                style={{
                                    fontWeight: 700,
                                    fontSize: 16,
                                }}
                            >
                                {reconocimiento.nombre_empleado ||
                                    reconocimiento.idempleado_nombre ||
                                    "-"}
                            </div>
                        </div>

                        <div style={infoBoxStyle}>
                            <div
                                style={{
                                    fontSize: 12,
                                    textTransform: "uppercase",
                                    color: "#6b7280",
                                    marginBottom: 6,
                                }}
                            >
                                Tipo de reconocimiento
                            </div>

                            <div
                                style={{
                                    fontWeight: 700,
                                    fontSize: 16,
                                }}
                            >
                                {reconocimiento.tipocarta || "-"}
                            </div>
                        </div>

                        <div style={infoBoxStyle}>
                            <div
                                style={{
                                    fontSize: 12,
                                    textTransform: "uppercase",
                                    color: "#6b7280",
                                    marginBottom: 6,
                                }}
                            >
                                Fecha
                            </div>

                            <div
                                style={{
                                    fontWeight: 700,
                                    fontSize: 16,
                                }}
                            >
                                {formatDate(reconocimiento.fecha)}
                            </div>
                        </div>

                        <div style={infoBoxStyle}>
                            <div
                                style={{
                                    fontSize: 12,
                                    textTransform: "uppercase",
                                    color: "#6b7280",
                                    marginBottom: 6,
                                }}
                            >
                                Responsable
                            </div>

                            <div
                                style={{
                                    fontWeight: 700,
                                    fontSize: 16,
                                }}
                            >
                                {reconocimiento.nombre_responsable || "-"}
                            </div>
                        </div>

                        <div
                            style={{
                                gridColumn: "1 / -1",
                                ...infoBoxStyle,
                            }}
                        >
                            <div
                                style={{
                                    fontSize: 12,
                                    textTransform: "uppercase",
                                    color: "#6b7280",
                                    marginBottom: 6,
                                }}
                            >
                                Cargo Responsable
                            </div>

                            <div
                                style={{
                                    fontWeight: 600,
                                    fontSize: 16,
                                }}
                            >
                                {reconocimiento.cargo_responsable || "-"}
                            </div>
                        </div>

                        <div
                            style={{
                                gridColumn: "1 / -1",
                                ...infoBoxStyle,
                            }}
                        >
                            <div
                                style={{
                                    fontSize: 12,
                                    textTransform: "uppercase",
                                    color: "#6b7280",
                                    marginBottom: 6,
                                }}
                            >
                                Documento firmado
                            </div>

                            {documento?.archivo_url ? (
                                <a
                                    href={documento.archivo_url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                        color: "#2563eb",
                                        textDecoration: "underline",
                                    }}
                                >
                                    {documento.nombrearchivo}
                                </a>
                            ) : (
                                "Pendiente de carga"
                            )}
                        </div>
                    </div>
                </Section>
            </div>
        </div>
    );
};

export default ReconocimientoModal;